import { render, staticRenderFns } from "./SubscribeLayout.vue?vue&type=template&id=29bf68e3"
var script = {}
import style0 from "./SubscribeLayout.vue?vue&type=style&index=0&id=29bf68e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports